'use client';

import _defineProperty from "/codebuild/output/src3207/src/s3/01/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/codebuild/output/src3207/src/s3/01/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "refProp", "withKeyboardNavigation", "withAriaAttributes", "withExpandedAttribute", "targetType", "autoComplete"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { cloneElement } from 'react';
import { useMergedRef } from '@mantine/hooks';
import { isElement } from '../../../core/utils/is-element/is-element.mjs';
import 'react/jsx-runtime';
import 'clsx';
import '../../../core/MantineProvider/Mantine.context.mjs';
import '../../../core/MantineProvider/default-theme.mjs';
import '../../../core/MantineProvider/MantineProvider.mjs';
import '../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs';
import { useProps } from '../../../core/MantineProvider/use-props/use-props.mjs';
import '../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs';
import '../../../core/Box/Box.mjs';
import { factory } from '../../../core/factory/factory.mjs';
import '../../../core/DirectionProvider/DirectionProvider.mjs';
import { useComboboxContext } from '../Combobox.context.mjs';
import { useComboboxTargetProps } from '../use-combobox-target-props/use-combobox-target-props.mjs';
var defaultProps = {
  refProp: "ref",
  targetType: "input",
  withKeyboardNavigation: true,
  withAriaAttributes: true,
  withExpandedAttribute: false,
  autoComplete: "off"
};
var ComboboxEventsTarget = factory(function (props, ref) {
  var _useProps = useProps("ComboboxEventsTarget", defaultProps, props),
    children = _useProps.children,
    refProp = _useProps.refProp,
    withKeyboardNavigation = _useProps.withKeyboardNavigation,
    withAriaAttributes = _useProps.withAriaAttributes,
    withExpandedAttribute = _useProps.withExpandedAttribute,
    targetType = _useProps.targetType,
    autoComplete = _useProps.autoComplete,
    others = _objectWithoutProperties(_useProps, _excluded);
  if (!isElement(children)) {
    throw new Error("Combobox.EventsTarget component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported");
  }
  var ctx = useComboboxContext();
  var targetProps = useComboboxTargetProps({
    targetType: targetType,
    withAriaAttributes: withAriaAttributes,
    withKeyboardNavigation: withKeyboardNavigation,
    withExpandedAttribute: withExpandedAttribute,
    onKeyDown: children.props.onKeyDown,
    autoComplete: autoComplete
  });
  return cloneElement(children, _objectSpread(_objectSpread(_objectSpread({}, targetProps), others), {}, _defineProperty({}, refProp, useMergedRef(ref, ctx.store.targetRef, children === null || children === void 0 ? void 0 : children.ref))));
});
ComboboxEventsTarget.displayName = "@mantine/core/ComboboxEventsTarget";
export { ComboboxEventsTarget };